/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = MFGTransactionItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MFGTransactionItemsEditor extends _Ext.MFGTransItemGridEditor<MFGTransactionItemsRow> {



        protected getColumnsKey() { return "Production.MFGTransactionItems"; }
        protected getDialogType() { return MFGTransactionItemsDialog; }
        protected getLocalTextPrefix() { return MFGTransactionItemsRow.localTextPrefix; }
        protected form: MFGTransactionItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public DepartmentId: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;
        isEditable: boolean;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.isEditable = this.slickGrid.getOptions().editable;

            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }
        public Editable() {
            this.isEditable = true;
        }


        private Master;
        //public setEditValue(source: DismantlingRow, property) {
        //    super.setOwnerEntity(source);
        //    this.Master = source;
        //    super.setEditValue(source, property);
        //}

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);

            // passing category ID from grid editor to detail dialog
            //if (this.DepartmentId == 0 || this.DepartmentId == null) {
            //    Q.notifyWarning("Please select department");
            //    return;

            //} else {
            //    (dialog as MFGTransactionItemsDialog).departmentid = this.DepartmentId;
            //}
        }


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons[0].title = "New Transaction"; 
            return buttons;
        }


    }
}